export const eventRefereeConstants = {
  ADD_REFEREE_REQUEST: 'ADD_REFEREE_REQUEST',
  ADD_REFEREE_SUCCESS: 'ADD_REFEREE_SUCCESS',
  ADD_REFEREE_FAILURE: 'ADD_REFEREE_FAILURE',
  REMOVE_REFEREE_REQUEST: 'REMOVE_REFEREE_REQUEST',
  REMOVE_REFEREE_SUCCESS: 'REMOVE_REFEREE_SUCCESS',
  REMOVE_REFEREE_FAILURE: 'REMOVE_REFEREE_FAILURE',
  GET_REFEREES_REQUEST: 'GET_REFEREES_REQUEST',
  GET_REFEREES_SUCCESS: 'GET_REFEREES_SUCCESS',
  GET_REFEREES_FAILURE: 'GET_REFEREES_FAILURE',
  GET_AVAILABLE_REFEREES_REQUEST: 'GET_AVAILABLE_REFEREES_REQUEST',
  GET_AVAILABLE_REFEREES_SUCCESS: 'GET_AVAILABLE_REFEREES_SUCCESS',
  GET_AVAILABLE_REFEREES_FAILURE: 'GET_AVAILABLE_REFEREES_FAILURE',
};
